// Imports
import styled from "styled-components"
import SyntaxHighlighter from "react-syntax-highlighter"

import { Variables, Mixins } from "fajny-react"

const Container = styled.div`
    position: relative;
    width: 100%;
    overflow-x: hidden;
    background-color: ${Variables.Colors.Gray900};
`

const Code = styled(SyntaxHighlighter)`
    width: 100%;
    padding: ${({ $noPadding }) =>
        $noPadding ? 0 : Variables.Spacers.L} !important;
    background-color: transparent !important;
    padding: ${Variables.Spacers.M} !important;

    pre {
        padding: 0 !important;
    }

    code {
        font-family: ${Variables.FontFamilies.Code} !important;
        background-color: transparent !important;

        & > * {
            font-family: ${Variables.FontFamilies.Code} !important;
            background-color: transparent !important;
        }
    }
`

const buttonSize = 32

const Button = styled.button`
    position: absolute;
    top: calc(51px / 2 - ${buttonSize}px / 2);
    right: ${Variables.Spacers.M};
    z-index: 10;
    width: ${buttonSize}px;
    height: ${buttonSize}px;
    border-radius: ${Variables.Radiuses.Circle};
    border: none;
    background-color: ${({ $hasCopied }) =>
        $hasCopied ? Variables.Colors.Success500 : Variables.Colors.White};
    color: ${({ $hasCopied }) =>
        $hasCopied ? Variables.Colors.White : Variables.Colors.Primary500};
    ${Mixins.Flexbox({
        $inline: true,
        $align: "center",
        $justify: "center",
    })};
    transition: ${Variables.Transitions.Short};

    &:hover {
        background-color: ${({ $hasCopied }) =>
            $hasCopied
                ? Variables.Colors.Success300
                : Variables.Colors.Gray300};
    }

    &:active {
        background-color: ${({ $hasCopied }) =>
            $hasCopied
                ? Variables.Colors.Success600
                : Variables.Colors.Gray100};
    }

    @media ${Variables.Breakpoints.Touch} {
        display: none;
    }
`

export { Container, Code, Button }
